var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndDoubleQuotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xE2\x80\x9C",
    d: "M21.6797 29.7656L21.6797 23.7891C23.5547 23.6849 24.974 23.3333 25.9375 22.7344C26.901 22.1615 27.5781 21.2109 27.9688 19.8828C28.3594 18.5807 28.5547 16.7057 28.5547 14.2578L21.6797 14.2578L21.6797 -1.2328e-06L35.7813 0L35.7813 13.5547C35.7813 19.1536 34.5964 23.2552 32.2266 25.8594C29.8307 28.4635 26.3151 29.7656 21.6797 29.7656ZM0.390625 29.7656L0.390626 23.7891C2.26563 23.6849 3.6849 23.3464 4.64844 22.7734C5.61198 22.2266 6.3151 21.276 6.75781 19.9219C7.17448 18.5937 7.38281 16.7057 7.38281 14.2578L0.390626 14.2578L0.390628 -3.09395e-06L14.5703 -1.85432e-06L14.5703 13.5547C14.5703 19.1536 13.3854 23.2552 11.0156 25.8594C8.64583 28.4635 5.10417 29.7656 0.390625 29.7656Z",
    fill: "#252429",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndDoubleQuotation);
export default __webpack_public_path__ + "static/media/end-double-quotation.87830468acc99034d3fc52857d27ee37.svg";
export { ForwardRef as ReactComponent };